import { render, staticRenderFns } from "./insuranceCompanyNews.vue?vue&type=template&id=27b96ba1&scoped=true&"
import script from "./insuranceCompanyNews.vue?vue&type=script&lang=js&"
export * from "./insuranceCompanyNews.vue?vue&type=script&lang=js&"
import style0 from "./insuranceCompanyNews.vue?vue&type=style&index=0&id=27b96ba1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b96ba1",
  null
  
)

export default component.exports